import {
  LEAD_FORM_CONTRACTS,
  LEAD_FORM_TYPE,
} from "@homeinstead/forms/lead-form";

/** The care seeker contract's field schemas, which every lead flow submits. */
const CONTRACT_SHAPE =
  LEAD_FORM_CONTRACTS[LEAD_FORM_TYPE.careSeeker].submitSchema.shape;

export { CONTRACT_SHAPE };
